export type ProfilePhotoIssue =
  | 'not_a_person'
  | 'multiple_people'
  | 'poor_quality';

export const isBlockingPhotoIssue = (
  issue: ProfilePhotoIssue | null,
): issue is 'not_a_person' | 'multiple_people' =>
  issue === 'not_a_person' || issue === 'multiple_people';
